import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="bg-gray-50 py-20 px-4 border-t border-gray-200" data-id="element-201">
      <div className="max-w-3xl mx-auto" data-id="element-202">
        <div className="text-center mb-10" data-id="element-203">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-204">
            — SIN RIESGO —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-black text-center leading-tight mb-16 font-montserrat" data-id="element-205">
          "Garantía Total de 30 Días: Si No Estás Satisfecho, te Devolvemos el
          Dinero. Sin Preguntas."
        </h2>

        <div className="bg-neon rounded-3xl border-4 border-black p-8 md:p-12 shadow-neon-lg relative mb-16" data-id="element-206">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black text-neon font-black px-8 py-3 rounded-full flex items-center gap-3 shadow-xl border-2 border-neon" data-id="element-207">
            <ShieldCheck className="w-6 h-6" data-id="element-208" />
            <span className="tracking-widest" data-id="element-209">GARANTÍA 30 DÍAS</span>
          </div>

          <div className="text-black text-lg md:text-xl font-bold leading-relaxed space-y-6 mt-8 text-center" data-id="element-210">
            <p data-id="element-211">
              Si por cualquier razón El Método 500€ no cumple tus expectativas
              en los próximos 30 días, solo escríbenos un email y te devolvemos
              el 100% de tu dinero.
            </p>
            <p className="text-2xl font-black uppercase tracking-tight" data-id="element-212">
              Sin preguntas. Sin burocracia. Sin letra pequeña.
            </p>
            <div className="border-t-4 border-black pt-6 mt-6" data-id="element-213">
              <p className="text-3xl font-black bg-black text-white inline-block px-6 py-2 rounded-lg transform -rotate-2" data-id="element-214">
                El riesgo es completamente nuestro.
              </p>
            </div>
          </div>
        </div>

        <CTAButton data-id="element-215" />
      </div>
    </section>;
}